var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.accordionCSSClass},[_c('button',{class:_vm.triggerCSSClass,on:{"click":_vm.toggleAccordion}},[_vm._t("trigger")],2),_vm._v(" "),_c('div',{class:_vm.panelCSSClass},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }